import React from "react";
import VTStage from "../page/VTStage";
import Header from "../header/Header";
import Footer from "../footer/Footer";

/**
 * Shows Venue Stage for tips
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingStage() {
    return (
        <>
            <Header/>
            <VTStage/>
            <Footer/>
        </>
    );
}